import { Routes } from '@angular/router';

export const posRoutes: Routes = [
  // Asset Type
  {
    path: 'asset-type',
    data: { moduleCode: 'pos_asset_type' },
    children: [
      { path: '', loadComponent: () => import('./asset-type/asset-type').then((m) => m.AssetType) },
      { path: 'add', loadComponent: () => import('./asset-type/asset-type-details/asset-type-details').then((m) => m.AssetTypeDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./asset-type/asset-type-details/asset-type-details').then((m) => m.AssetTypeDetails)
      },
      { path: 'import', loadComponent: () => import('./asset-type/asset-type-import/asset-type-import').then((m) => m.AssetTypeImport) }
    ]
  },
  // Cash and Shift
  {
    path: 'cash-and-shift',
    data: { moduleCode: 'pos_cash_shift' },
    children: [
      { path: '', loadComponent: () => import('./cash-and-shift/cash-and-shift').then((m) => m.CashAndShift) },
      {
        path: 'add',
        loadComponent: () => import('./cash-and-shift/cash-and-shift-details/cash-and-shift-details').then((m) => m.CashAndShiftDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./cash-and-shift/cash-and-shift-details/cash-and-shift-details').then((m) => m.CashAndShiftDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./cash-and-shift/cash-and-shift-import/cash-and-shift-import').then((m) => m.CashAndShiftImport)
      }
    ]
  },
  // Configuration
  {
    path: 'pos-configuration',
    data: { moduleCode: 'pos_config' },
    children: [{ path: '', loadComponent: () => import('./pos-configuration/pos-configuration').then((m) => m.PosConfiguration) }]
  },
  // Integration and System controls
  {
    path: 'integration-and-system-controls',
    data: { moduleCode: 'pos_integration_sys_controls' },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./integration-and-system-controls/integration-and-system-controls').then((m) => m.IntegrationAndSystemControls)
      }
    ]
  },
  // Content Management
  {
    path: 'content-management',
    data: { moduleCode: 'pos_content_mgmt' },
    children: [
      { path: '', loadComponent: () => import('./content-management/content-management').then((m) => m.ContentManagement) },
      {
        path: 'add',
        loadComponent: () =>
          import('./content-management/content-management-details/content-management-details').then((m) => m.ContentManagementDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./content-management/content-management-details/content-management-details').then((m) => m.ContentManagementDetails)
      },
      {
        path: 'import',
        loadComponent: () =>
          import('./content-management/content-management-import/content-management-import').then((m) => m.ContentManagementImport)
      }
    ]
  },
  // POS Assets
  {
    path: 'pos-assets',
    data: { moduleCode: 'pos_pos_assets' },
    children: [
      { path: '', loadComponent: () => import('./pos-assets/pos-assets').then((m) => m.PosAssets) },
      { path: 'add', loadComponent: () => import('./pos-assets/pos-assets-details/pos-assets-details').then((m) => m.PosAssetsDetails) },
      {
        path: 'details/:id',
        loadComponent: () => import('./pos-assets/pos-assets-details/pos-assets-details').then((m) => m.PosAssetsDetails)
      },
      { path: 'import', loadComponent: () => import('./pos-assets/pos-assets-import/pos-assets-import').then((m) => m.PosAssetsImport) }
    ]
  },
  // New Content Creation
  {
    path: 'new-content-creation',
    data: { moduleCode: 'pos_new_content_creation' },
    children: [
      { path: '', loadComponent: () => import('./new-content-creation/new-content-creation').then((m) => m.NewContentCreation) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./new-content-creation/new-content-creation-details/new-content-creation-details').then(
            (m) => m.NewContentCreationDetails
          )
      }
    ]
  },
  // Content Update
  {
    path: 'content-update',
    data: { moduleCode: 'pos_content_upd' },
    children: [
      { path: '', loadComponent: () => import('./content-update/content-update').then((m) => m.ContentUpdate) },
      {
        path: 'details/:id',
        loadComponent: () => import('./content-update/content-update-details/content-update-details').then((m) => m.ContentUpdateDetails)
      }
    ]
  },
  // Switch Store Approval
  {
    path: 'switch-store',
    data: { moduleCode: 'pos_switch_store' },
    children: [
      { path: '', loadComponent: () => import('./switch-store/switch-store').then((m) => m.SwitchStore) },
      {
        path: 'details/:id',
        loadComponent: () => import('./switch-store/switch-store-details/switch-store-details').then((m) => m.SwitchStoreDetails)
      }
    ]
  },
  // Voucher Profile
  {
    path: 'voucher-profile',
    data: { moduleCode: 'vouch_profile' },
    children: [
      { path: '', loadComponent: () => import('./voucher/voucher-profile/voucher-profile').then((m) => m.VoucherProfile) },
      {
        path: 'add',
        loadComponent: () =>
          import('./voucher/voucher-profile/voucher-profile-details/voucher-profile-details').then((m) => m.VoucherProfileDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./voucher/voucher-profile/voucher-profile-details/voucher-profile-details').then((m) => m.VoucherProfileDetails)
      },
      {
        path: 'import',
        loadComponent: () => import('./voucher/voucher-import/voucher-import').then((m) => m.VoucherImport)
      }
    ]
  },
  // New Voucher
  {
    path: 'new-voucher-creation',
    data: { moduleCode: 'vouch_new_creation' },
    children: [
      { path: '', loadComponent: () => import('./voucher/new-voucher-req/new-voucher-req').then((m) => m.NewVoucherReq) },
      {
        path: 'add',
        loadComponent: () =>
          import('./voucher/new-voucher-req/new-voucher-req-details/new-voucher-req-details').then((m) => m.NewVoucherReqDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./voucher/new-voucher-req/new-voucher-req-details/new-voucher-req-details').then((m) => m.NewVoucherReqDetails)
      }
    ]
  },

  // Update Voucher
  {
    path: 'voucher-details-update',
    data: { moduleCode: 'vouch_details_upd' },
    children: [
      { path: '', loadComponent: () => import('./voucher/update-voucher-req/update-voucher-req').then((m) => m.UpdateVoucherReq) },
      {
        path: 'add',
        loadComponent: () =>
          import('./voucher/update-voucher-req/update-voucher-req-details/update-voucher-req-details').then(
            (m) => m.UpdateVoucherReqDetails
          )
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./voucher/update-voucher-req/update-voucher-req-details/update-voucher-req-details').then(
            (m) => m.UpdateVoucherReqDetails
          )
      }
    ]
  }
];
